import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '@/services/TranslationService';

const useTranslation = () => {
  const selectedLanguage = useSelector(
    (state) => state.settingsReducer?.selectedLanguage
  );
  const translations = useSelector(
    (state) => state.translationsReducer?.translations
  );

  return useCallback((key) => translate(key), [
    selectedLanguage,
    translations,
  ]);
};

export default useTranslation;
